import { FC } from 'react'

import { Layout, Typography } from '@/components/ui'
import Spinner from '@/components/ui/spinner/Spinner'

import HistoryLegend from './components/HistoryLegend'
import HistoryTable from './components/HistoryTable'
import { useHistory } from './hooks/useHistory'

const History: FC = () => {
	const { historyRows, isHistoryLoading, isError, isEmpty } = useHistory()

	return (
		<Layout>
			<div className='p-[50px]'>
				<Typography variant='h2' className='text-[32px] text-center'>
					Highlights history
				</Typography>

				{/* Statuses legend */}
				<HistoryLegend />

				{/* Highlights table */}
				{isHistoryLoading ? (
					<Spinner />
				) : isError ? (
					<div className='mt-[100px]'>
						<Typography variant='h2' className='text-[24px] text-center'>
							Failed to load highlights history
						</Typography>
					</div>
				) : isEmpty ? (
					<div className='mt-[100px]'>
						<Typography variant='h2' className='text-[24px] text-center'>
							There are no highlights yet
						</Typography>
					</div>
				) : (
					<HistoryTable historyRows={historyRows} />
				)}
			</div>
		</Layout>
	)
}

export default History
